import axios from './../axiosInstance';

export function synchronizeRegionsApi() {
    return axios.get(`/regions/synchronize`).then(res => res.data);
}
